import React from "react";
import {
  View,
  Text,
  ActivityIndicator,
  Platform,
} from "react-native";
import Modal from "react-native-modal";
import { Ionicons } from "@expo/vector-icons";
import { Row } from "./all";
import { normalize } from "../utils/normalize";
import { COUNTRIES } from "../constants/countries";

const JobCreationProgress = ({ visible, progress }) => {
  const getCountryInfo = (countryCode) => {
    return COUNTRIES[countryCode] || { name: countryCode, flag: '🏳️' };
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return <Ionicons name="time-outline" size={20} color="#999" />;
      case 'in_progress':
        return <ActivityIndicator size="small" color="#4B9BFF" />;
      case 'success':
        return <Ionicons name="checkmark-circle" size={20} color="#4CAF50" />;
      case 'failed':
        return <Ionicons name="close-circle" size={20} color="#FF4B4B" />;
      default:
        return null;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'pending':
        return 'Waiting...';
      case 'in_progress':
        return 'Creating job...';
      case 'success':
        return 'Job created';
      case 'failed':
        return 'Failed';
      default:
        return '';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return '#999';
      case 'in_progress':
        return '#4B9BFF';
      case 'success':
        return '#4CAF50';
      case 'failed':
        return '#FF4B4B';
      default:
        return '#666';
    }
  };

  return (
    <Modal
      isVisible={visible}
      animationType="fade"
      backdropOpacity={0.7}
      useNativeDriverForBackdrop={true}
      style={{
        margin: 0,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <View
        style={{
          backgroundColor: "white",
          borderRadius: 16,
          width: Platform.OS === "web" ? 400 : "85%",
          maxWidth: 400,
          padding: 24,
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 2,
          },
          shadowOpacity: 0.25,
          shadowRadius: 3.84,
          elevation: 5,
        }}
      >
        {/* Header */}
        <View style={{ alignItems: "center", marginBottom: 24 }}>
          <View
            style={{
              width: 60,
              height: 60,
              borderRadius: 30,
              backgroundColor: "#F0F8FF",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <Ionicons name="briefcase-outline" size={28} color="#4B9BFF" />
          </View>
          <Text
            style={{
              fontSize: normalize(18),
              fontWeight: "600",
              color: "#333",
              marginBottom: 4,
            }}
          >
            Creating Jobs
          </Text>
          <Text
            style={{
              fontSize: normalize(14),
              color: "#666",
              textAlign: "center",
            }}
          >
            Creating your job posting for multiple countries
          </Text>
        </View>

        {/* Progress Summary */}
        <View
          style={{
            backgroundColor: "#F8F9FA",
            borderRadius: 8,
            padding: 12,
            marginBottom: 16,
          }}
        >
          <Text
            style={{
              fontSize: normalize(14),
              color: "#333",
              textAlign: "center",
            }}
          >
            {progress?.completed} of {progress?.total} completed
          </Text>
        </View>

        {/* Country Progress List */}
        <View style={{ marginBottom: 8 }}>
          {progress?.countries.map((country, index) => {
            const countryInfo = getCountryInfo(country.code);
            return (
              <Row
                key={country.code}
                style={{
                  paddingVertical: 12,
                  borderBottomWidth: index < progress?.countries.length - 1 ? 1 : 0,
                  borderBottomColor: "#F0F0F0",
                }}
              >
                <Text style={{ fontSize: normalize(18), marginRight: 12 }}>
                  {countryInfo.flag}
                </Text>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: normalize(15),
                      color: "#333",
                      fontWeight: "500",
                    }}
                  >
                    {countryInfo.name}
                  </Text>
                  <Text
                    style={{
                      fontSize: normalize(12),
                      color: getStatusColor(country.status),
                      marginTop: 2,
                    }}
                  >
                    {getStatusText(country.status)}
                    {country.error && (
                      <Text style={{ color: "#FF4B4B" }}>
                        {' - '}{country.error}
                      </Text>
                    )}
                  </Text>
                </View>
                {getStatusIcon(country.status)}
              </Row>
            );
          })}
        </View>

        {/* Loading Message */}
        {progress?.completed < progress?.total && (
          <Text
            style={{
              fontSize: normalize(12),
              color: "#666",
              textAlign: "center",
              marginTop: 8,
              fontStyle: "italic",
            }}
          >
            Please wait while we create your job postings...
          </Text>
        )}
      </View>
    </Modal>
  );
};

export default JobCreationProgress;